import { get_session9cytjmfbg8nd as get_session } from '../../../../sdk/UserSession.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { requestFiles2wr6y980phloh as requestFiles } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  LocalFileyitm5ua4ch17 as LocalFile,
  FileDataw8niis0ucpno as FileData,
  resolveProjectAttachments1r3ylk2p3xmwv as resolveProjectAttachments,
} from '../../files/attachmentFilePreview.mjs';
import { modify3tvoxz8jo60p8 as modify } from '../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { asyncz02dsa2nb2zt as async } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { awaitAll3u8r91uegk3sa as awaitAll } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Await.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { ProjectSettlementDocumentation1o22wkmr8w8uo as ProjectSettlementDocumentation } from '../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
} from '../../nav/crowpay.mjs';
import { confirmationDialog1lynowl7yd4cd as confirmationDialog } from '../../../dialogs/GenericConfirmationDialog.mjs';
import { ViewSettlementDocs1y21duy3panzg as ViewSettlementDocs } from './ViewSettlementDocs.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { navigateTo251lpwmg2lk0y as navigateTo } from '../../../../utils/utils.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { IssueNode2x8c6ia7dmfdz as IssueNode } from '../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/IssueNode.mjs';
import { validated3dw9xce8adqbh as validated } from '../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import { assert1ckwbdkg35i20 as assert } from '../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { ReactiveMutableList2gg4x024enrbf as ReactiveMutableList } from '../../../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableList.mjs';
import {
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrollingHorizontally3ifk3kuuwhjjn as get_scrollingHorizontally,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../nav/AppDimensions.mjs';
import {
  get_atTopCenter1v6irntzl0tu6 as get_atTopCenter,
  get_atEnd1cw5d2zgug26 as get_atEnd,
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import {
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
  bodyBold2czwdzwknab0k as bodyBold,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
} from '../../../theming/Titles.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  align1ejncrrer3meh as align,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../theming/AppColors.mjs';
import { notificationBar4efejtg2792g as notificationBar } from '../../../theming/banners.mjs';
import {
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  divkhq3vjih9fcw as div,
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { colored3y8uibz1hk46 as colored } from '../../../theming/colorManagement.mjs';
import { validategsg6go7eyi9d as validate } from '../../../../utils/validation.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { issueText2dqtp9rg036jt as issueText } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/validation.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { fileCarousely0kamh1gns47 as fileCarousel } from '../../files/fileManager.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$async, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = $this.yh1_1.zgb(LiveApi2$Api2ProjectSettlementDocumentationLive$uploadFileForRequest$ref_0(tmp$ret$0.vfw().ufg_1), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var LiveApi2$Api2ProjectSettlementDocumentationLive$uploadFileForRequest$refClass;
function LiveApi2$Api2ProjectSettlementDocumentationLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2ProjectSettlementDocumentationLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.zh1_1 = p0;
      }
      uao($completion) {
        return this.zh1_1.lfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2ProjectSettlementDocumentationLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2ProjectSettlementDocumentationLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2ProjectSettlementDocumentationLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2ProjectSettlementDocumentationLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.uao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = requestFiles($this.ah2_1.pc(), VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.map' call
  var this_0 = tmp;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var preview = new (LocalFile())(item);
    var tmp_0 = modify($this.bh2_1.ih2_1, UploadSettlementDocsDialog$render$slambda$slambda_0(preview), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp$ret$0 = async($this.ah2_1, VOID, VOID, UploadSettlementDocsDialog$render$slambda$slambda_2(preview));
    destination.v(tmp$ret$0);
  }
  var tmp_1 = awaitAll(destination, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
var UploadSettlementDocsDialog$render$slambda$slambdaClass;
function UploadSettlementDocsDialog$render$slambda$slambda() {
  if (UploadSettlementDocsDialog$render$slambda$slambdaClass === VOID) {
    class $ {
      constructor($preview) {
        this.kh2_1 = $preview;
      }
      qge(it, $completion) {
        return plus(it, new (FileData())(VOID, Signal().hak(''), this.kh2_1, this.kh2_1));
      }
      s2(p1, $completion) {
        return this.qge((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    UploadSettlementDocsDialog$render$slambda$slambdaClass = $;
  }
  return UploadSettlementDocsDialog$render$slambda$slambdaClass;
}
function UploadSettlementDocsDialog$render$slambda$slambda_0($preview) {
  var i = new (UploadSettlementDocsDialog$render$slambda$slambda())($preview);
  var l = (it, $completion) => i.qge(it, $completion);
  l.$arity = 1;
  return l;
}
var UploadSettlementDocsDialog$render$slambda$slambdaClass_0;
function UploadSettlementDocsDialog$render$slambda$slambda_1() {
  if (UploadSettlementDocsDialog$render$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($preview) {
        this.yh1_1 = $preview;
      }
      yah($this$async, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$async), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    UploadSettlementDocsDialog$render$slambda$slambdaClass_0 = $;
  }
  return UploadSettlementDocsDialog$render$slambda$slambdaClass_0;
}
function UploadSettlementDocsDialog$render$slambda$slambda_2($preview) {
  var i = new (UploadSettlementDocsDialog$render$slambda$slambda_1())($preview);
  var l = ($this$async, $completion) => i.yah($this$async, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.lh2_1.ih2_1;
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = resolveProjectAttachments(tmp$ret$0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var files = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var session = tmp_1;
  var tmp0_submitted = session.wfw();
  var tmp1_project = $this.lh2_1.ch2_1.v7a_1;
  var tmp2_summary = $this.lh2_1.hh2_1.f2();
  var tmp3_submittedByClient = $this.lh2_1.dh2_1.zgj();
  var tmp_2 = session.ofw_1.beo(new (ProjectSettlementDocumentation())(VOID, tmp1_project, tmp0_submitted, tmp3_submittedByClient, tmp2_summary, files), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  get_dialogStack().wgg();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.mh2_1.gh2_1.rat_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!tmp.i1()) {
    $this.mh2_1.jh2_1.oam(true);
    return Unit_instance;
  }
  $this.mh2_1.jh2_1.oam(false);
  confirmationDialog($this.nh2_1, 'Submit Settlement?', 'Stoze and the other party will be notified of this settlement submission. Stoze will verify the documents and process fund disbursement according to the decision. This may take several business days.', 'Submit', VOID, VOID, VOID, VOID, VOID, VOID, UploadSettlementDocsDialog$render$slambda$slambda_4($this.mh2_1));
  return Unit_instance;
}
var UploadSettlementDocsDialog$render$slambda$slambdaClass_1;
function UploadSettlementDocsDialog$render$slambda$slambda_3() {
  if (UploadSettlementDocsDialog$render$slambda$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.lh2_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UploadSettlementDocsDialog$render$slambda$slambdaClass_1 = $;
  }
  return UploadSettlementDocsDialog$render$slambda$slambdaClass_1;
}
function UploadSettlementDocsDialog$render$slambda$slambda_4(this$0) {
  var i = new (UploadSettlementDocsDialog$render$slambda$slambda_3())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function UploadSettlementDocsDialog$files$lambda(it) {
  // Inline function 'kotlin.collections.isNotEmpty' call
  return !it.i1();
}
var UploadSettlementDocsDialog$render$slambdaClass;
function UploadSettlementDocsDialog$render$slambda() {
  if (UploadSettlementDocsDialog$render$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UploadSettlementDocsDialog$render$slambdaClass = $;
  }
  return UploadSettlementDocsDialog$render$slambdaClass;
}
function UploadSettlementDocsDialog$render$slambda_0() {
  var i = new (UploadSettlementDocsDialog$render$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var UploadSettlementDocsDialog$render$slambdaClass_0;
function UploadSettlementDocsDialog$render$slambda_1() {
  if (UploadSettlementDocsDialog$render$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.oh2_1 = $$this$button;
        this.ph2_1 = this$0;
      }
      uao($completion) {
        if (get_viewIsNarrow(this.oh2_1)) {
          get_dialogStack().wgg();
          navigateTo(get_mainPageNavigator(this.oh2_1), new (ViewSettlementDocs())(this.ph2_1.ch2_1.v7a_1, this.ph2_1.dh2_1, this.ph2_1.eh2_1));
        } else {
          get_dialogStack().fbw(new (ViewSettlementDocs())(this.ph2_1.ch2_1.v7a_1, this.ph2_1.dh2_1, this.ph2_1.eh2_1));
        }
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UploadSettlementDocsDialog$render$slambdaClass_0 = $;
  }
  return UploadSettlementDocsDialog$render$slambdaClass_0;
}
function UploadSettlementDocsDialog$render$slambda_2($$this$button, this$0) {
  var i = new (UploadSettlementDocsDialog$render$slambda_1())($$this$button, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var UploadSettlementDocsDialog$render$slambdaClass_1;
function UploadSettlementDocsDialog$render$slambda_3() {
  if (UploadSettlementDocsDialog$render$slambdaClass_1 === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.ah2_1 = $$this$button;
        this.bh2_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UploadSettlementDocsDialog$render$slambdaClass_1 = $;
  }
  return UploadSettlementDocsDialog$render$slambdaClass_1;
}
function UploadSettlementDocsDialog$render$slambda_4($$this$button, this$0) {
  var i = new (UploadSettlementDocsDialog$render$slambda_3())($$this$button, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var UploadSettlementDocsDialog$render$slambdaClass_2;
function UploadSettlementDocsDialog$render$slambda_5() {
  if (UploadSettlementDocsDialog$render$slambdaClass_2 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.mh2_1 = this$0;
        this.nh2_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UploadSettlementDocsDialog$render$slambdaClass_2 = $;
  }
  return UploadSettlementDocsDialog$render$slambdaClass_2;
}
function UploadSettlementDocsDialog$render$slambda_6(this$0, $$this$button) {
  var i = new (UploadSettlementDocsDialog$render$slambda_5())(this$0, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var UploadSettlementDocsDialog$render$slambdaClass_3;
function UploadSettlementDocsDialog$render$slambda_7() {
  if (UploadSettlementDocsDialog$render$slambdaClass_3 === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UploadSettlementDocsDialog$render$slambdaClass_3 = $;
  }
  return UploadSettlementDocsDialog$render$slambdaClass_3;
}
function UploadSettlementDocsDialog$render$slambda_8() {
  var i = new (UploadSettlementDocsDialog$render$slambda_7())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var UploadSettlementDocsDialogClass;
function UploadSettlementDocsDialog() {
  if (UploadSettlementDocsDialogClass === VOID) {
    class $ {
      constructor(project, lens, source) {
        this.ch2_1 = project;
        this.dh2_1 = lens;
        this.eh2_1 = source;
        this.fh2_1 = 35;
        this.gh2_1 = new (IssueNode())();
        var tmp = this;
        var tmp_0 = validated(Signal().hak(''), this.gh2_1);
        var tmp_1 = 'Must be at least ' + this.fh2_1 + ' characters.';
        tmp.hh2_1 = assert(tmp_0, tmp_1, VOID, VOID, (it) => it.length >= this.fh2_1);
        var tmp_2 = this;
        var tmp_3 = validated(ReactiveMutableList().vam(), this.gh2_1);
        tmp_2.ih2_1 = assert(tmp_3, 'Required', VOID, VOID, UploadSettlementDocsDialog$files$lambda);
        this.jh2_1 = Signal().hak(false);
      }
      wd6(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.vbo(UploadSettlementDocsDialog$render$slambda_0());
        view.gba(get_AppDimensions().yg1_1);
        var tmp_0 = view.kbb(get_atTopCenter(view), sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(40)));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        var tmp0_vertical = get_rem(3);
        var tmp1_horizontal = get_rem(0);
        view_0.jba(Edges().ed0(tmp1_horizontal, tmp0_vertical));
        view_0.eb9(true);
        var tmp_1 = view_0.jbb(DialogSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        title(view_1, 'Settlement');
        var tmp_2 = view_1.kbb(shownWhen(view_1, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.daj(this.eh2_1.qh2()).i1();
        }), notificationBar(view_1, AppColors_getInstance().lfz_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_2.zbm(true);
        body(view_2, 'There are existing settlement documents, click here to view existing settlement documentation.');
        var tmp_3 = view_2.kbb(get_atEnd(view_2), get_secondaryButton(view_2));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Button())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        specCenteredText(view_3, 'View Settlement Documents');
        onClick(view_3, VOID, VOID, UploadSettlementDocsDialog$render$slambda_2(view_3, this));
        view_2.hbb(p_3, view_3);
        view_2.lbb(tmp_3, view_3);
        view_1.hbb(p_2, view_2);
        view_1.lbb(tmp_2, view_2);
        body(view_1, 'Submit the results of arbitration, court decision, or notarized mutual agreement along with supporting documents. Include contact information for the issuing party. Stoze will verify the submission before processing fund disbursement.');
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_4 = view_1.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
        view_1.gbb(p_4, view_4);
        view_4.zbm(true);
        view_4.bb9(div(view_4.mba().jb0_1, 2));
        // Inline function 'com.crowpay.views.components.requiredField' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.gbb(p_5, view_5);
        view_5.zbm(true);
        view_5.bb9(get_AppDimensions().pg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.gbb(p_6, view_6);
        view_6.zbm(false);
        view_6.bb9(get_AppDimensions().rg2_1);
        view_6.lbb(get_centered(view_6), bodyBold(view_6, 'Summary'));
        view_6.lbb(colored(view_6, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_6, '*'));
        view_5.hbb(p_6, view_6);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_4 = view_5.jbb(FieldSemantic_getInstance());
        var tmp_5 = sizeConstraints(view_5, VOID, VOID, get_rem(8));
        var tmp_6 = view_5.kbb(tmp_5, validate(view_5, this.hh2_1, ($this$validate) => $this$validate.daj(this.jh2_1)));
        // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (TextArea())(view_5.pc());
        var tmp0_elvis_lhs_7 = view_5.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
        view_5.gbb(p_7, view_7);
        view_7.zah(view_7.scl_1, this.hh2_1);
        view_7.vcl('Minimum ' + this.fh2_1 + ' characters');
        view_5.hbb(p_7, view_7);
        var tmp$ret$16 = view_5.lbb(tmp_6, view_7);
        view_5.lbb(tmp_4, tmp$ret$16);
        view_4.hbb(p_5, view_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowOrCol())(view_4.pc());
        var tmp0_elvis_lhs_8 = view_4.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_4 : tmp0_elvis_lhs_8;
        view_4.gbb(p_8, view_8);
        view_8.zbm(false);
        var tmp_7 = get_centered(view_8);
        var tmp_8 = get_issues(this.hh2_1);
        view_8.lbb(tmp_7, issueText(view_8, tmp_8, VOID, ($this$issueText) => $this$issueText.daj(this.jh2_1)));
        var tmp_9 = get_expanding(view_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (Space())(view_8.pc());
        var tmp0_elvis_lhs_9 = view_8.ebb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
        view_8.gbb(p_9, view_9);
        view_8.hbb(p_9, view_9);
        view_8.lbb(tmp_9, view_9);
        var tmp_10 = align(view_8, Align_End_getInstance(), Align_Center_getInstance());
        // Inline function 'com.crowpay.views.theming.smallBody' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (TextView())(view_8.pc());
        var tmp0_elvis_lhs_10 = view_8.ebb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
        view_8.gbb(p_10, view_10);
        view_10.lba(view_10.qb6_1.abf(SmallBodySemantic_getInstance()));
        var tmp_11 = KMutableProperty0();
        var tmp_12 = TextView$_get_content_$ref_4pzcwl(view_10);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('content', 0, tmp_11, tmp_12, TextView$_set_content_$ref_pketfb(view_10));
        reactiveScope(view_10, ($this$reactiveScope) => {
          var diff = this.fh2_1 - $this$reactiveScope.daj(this.hh2_1).length | 0;
          var tmp$ret$25 = diff > 0 ? '' + diff + ' characters remaining' : '';
          this_0.set(tmp$ret$25);
          return Unit_instance;
        });
        view_8.hbb(p_10, view_10);
        view_8.lbb(tmp_10, view_10);
        view_4.hbb(p_8, view_8);
        view_1.hbb(p_4, view_4);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label = 'Documents';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_11 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_11 = view_1.ebb_1;
        var p_11 = tmp0_elvis_lhs_11 == null ? view_1 : tmp0_elvis_lhs_11;
        view_1.gbb(p_11, view_11);
        view_11.zbm(true);
        view_11.bb9(get_AppDimensions().pg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_12 = new (RowOrCol())(view_11.pc());
        var tmp0_elvis_lhs_12 = view_11.ebb_1;
        var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
        view_11.gbb(p_12, view_12);
        view_12.zbm(false);
        view_12.bb9(get_AppDimensions().rg2_1);
        view_12.lbb(get_centered(view_12), bodyBold(view_12, label));
        view_12.lbb(colored(view_12, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_12, '*'));
        view_11.hbb(p_12, view_12);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_13 = view_11.jbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_13 = new (RowOrCol())(view_11.pc());
        var tmp0_elvis_lhs_13 = view_11.ebb_1;
        var p_13 = tmp0_elvis_lhs_13 == null ? view_11 : tmp0_elvis_lhs_13;
        view_11.gbb(p_13, view_13);
        view_13.zbm(false);
        view_13.lbb(view_13.kbb(get_scrollingHorizontally(view_13), get_expanding(view_13)), fileCarousel(view_13, this.ih2_1, 'No Uploads Yet'));
        var tmp_14 = view_13.kbb(sizeConstraints(view_13, VOID, VOID, VOID, VOID, VOID, div(get_AppDimensions().sg2_1, 3)), get_tertiaryButton(view_13));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_14 = new (Button())(view_13.pc());
        var tmp0_elvis_lhs_14 = view_13.ebb_1;
        var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
        view_13.gbb(p_14, view_14);
        view_14.lbb(get_centered(view_14), icon(view_14, Companion_getInstance().ycf_1, 'Add Files'));
        onClick(view_14, VOID, VOID, UploadSettlementDocsDialog$render$slambda_4(view_14, this));
        view_13.hbb(p_14, view_14);
        view_13.lbb(tmp_14, view_14);
        view_11.hbb(p_13, view_13);
        var tmp_15 = get_issues(this.ih2_1);
        var tmp$ret$52 = issueText(view_11, tmp_15, VOID, ($this$issueText) => $this$issueText.daj(this.jh2_1));
        view_11.lbb(tmp_13, tmp$ret$52);
        view_1.hbb(p_11, view_11);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_15 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_15 = view_1.ebb_1;
        var p_15 = tmp0_elvis_lhs_15 == null ? view_1 : tmp0_elvis_lhs_15;
        view_1.gbb(p_15, view_15);
        view_15.zbm(false);
        view_15.bb9(get_AppDimensions().kg2_1);
        var tmp_16 = get_primaryButton(view_15);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_16 = new (Button())(view_15.pc());
        var tmp0_elvis_lhs_16 = view_15.ebb_1;
        var p_16 = tmp0_elvis_lhs_16 == null ? view_15 : tmp0_elvis_lhs_16;
        view_15.gbb(p_16, view_16);
        specCenteredText(view_16, 'Submit Settlement');
        onClick(view_16, VOID, VOID, UploadSettlementDocsDialog$render$slambda_6(this, view_16));
        view_15.hbb(p_16, view_16);
        view_15.lbb(tmp_16, view_16);
        var tmp_17 = get_textButton(view_15);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_17 = new (Button())(view_15.pc());
        var tmp0_elvis_lhs_17 = view_15.ebb_1;
        var p_17 = tmp0_elvis_lhs_17 == null ? view_15 : tmp0_elvis_lhs_17;
        view_15.gbb(p_17, view_17);
        specCenteredText(view_17, 'Go Back');
        onClick(view_17, VOID, VOID, UploadSettlementDocsDialog$render$slambda_8());
        view_15.hbb(p_17, view_17);
        view_15.lbb(tmp_17, view_17);
        view_1.hbb(p_15, view_15);
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_1, view_1);
        view.hbb(p_0, view_0);
        view.lbb(tmp_0, view_0);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'UploadSettlementDocsDialog', VOID, VOID, [Page()]);
    UploadSettlementDocsDialogClass = $;
  }
  return UploadSettlementDocsDialogClass;
}
//region block: exports
export {
  UploadSettlementDocsDialog as UploadSettlementDocsDialog3j42xvchj1p9v,
};
//endregion

//# sourceMappingURL=UploadSettlementDocsDialog.mjs.map
